import { useState } from "react";
import { Col } from "reactstrap";
import { Btn, H5, Image, P } from "../../../../../AbstractElements";
import { ClickOut, MoscowLogin } from "../../../../../Constants/Constants";
import { dynamicImage } from "../../../../../Utils";
import CommonModal from "../../Common/CommonModal";
import StaticModalForm from "../../Common/StaticModalForm";
import CommonMoscowModalTitle from "../Common/CommonMoscowModalTitle";

const CustomModal2 = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const data = {
    isOpen: modal,
    center: true,
    toggler: toggle,
    bodyClass: "dark-sign-up social-profile text-start",
  };
  return (
    <Col xl="4" md="6" className="custom-alert text-center">
      <div className="card-wrapper border rounded-3 h-100">
        <div className="aria-demo-img">
          <CommonMoscowModalTitle heading="Modal 2 -" subHeading="Result Modal" text="Example of aria login form." />
          <div className="overflow-hidden">
            <Image className="img-fluid" src={dynamicImage(`alert/learning.png`)} alt="learning" />
            <Btn color="primary" className="mx-auto mt-3" onClick={toggle}>
              {ClickOut}
            </Btn>
          </div>
          <CommonModal modalData={data}>
            <div className="modal-toggle-wrapper">
              <H5>{MoscowLogin}</H5>
              <P>{"Fill in your information below to continue."}</P>
              <StaticModalForm toggle={toggle} />
            </div>
          </CommonModal>
        </div>
      </div>
    </Col>
  );
};
export default CustomModal2;
